
import React, { useEffect, useState } from "react";

import Loader from "../../components/Loader";
import AssetLibrary from "./AssetLibrary";
import { listAssets, readApiError } from "./printSignApi";
import { SIGNS_ROOT, SignsPage } from "./signPage";

/** Библиотека картинок: фоны, фото для блока преимуществ (3D-рендеры), свои иконки. */
const PrintSignLibraryPage = () => {
    const [assets, setAssets] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        listAssets()
            .then(setAssets)
            .catch(async (loadError) => setError(await readApiError(loadError, "Библиотека не открылась")));
    }, []);

    return (
        <SignsPage title="Библиотека картинок" subtitle="Фоны, фото для блока преимуществ, свои иконки" back={SIGNS_ROOT} backLabel="К вывескам">
            {assets ? <AssetLibrary assets={assets} onChanged={setAssets} /> : <div className="signsEditor__placeholder">{error || <Loader />}</div>}
        </SignsPage>
    );
};

export default PrintSignLibraryPage;
